module.exports = __webpack_public_path__ + "img/img-d394e4c7.d95e41e1.png";